module.exports = __webpack_public_path__ + "static/img/huaweiP30.846615ae.png";